import { MapLike } from '../core'
import { AttributeValidationError, AttributeValidationResult, AttributeValueRange } from './validationTypes'

const debug = false
/** tests that is number, ie not NaN, undefined or null */
export const isNonNaNNumber = (x: any | undefined | null): x is number => !!(typeof x === 'number' && !isNaN(x))

/** test that x is true or false, ie avoids !!true */
export const isBoolean = (x: any): x is boolean => x === true || x === false

export const isValidDate = (x: any): x is Date => x instanceof Date && !isNaN(x.getTime())

export const isNullish = (a: any): a is null | undefined => a === null || a === undefined

export const bothNullish = (a: any, b: any) => isNullish(a) && isNullish(b)

/** tests that x is set including null,  set includeNulls to false if nulls are to be tested for truthiness */
export const isKnownValue = (x: any, includeNulls?: boolean): x is null | boolean | object | string =>
  (includeNulls && x === null) || isBoolean(x) || !!x || isNonNaNNumber(x) || x === ''

export const validAttributeNumberValue = (value: any, range: AttributeValueRange): AttributeValidationResult => {
  const isNumber = isNonNaNNumber(value)
  const res: AttributeValidationResult = {
    isValid: false,
    error: AttributeValidationError.NOT_NUMBER,
  }
  switch (isNumber) {
    case true:
      {
        res.error = AttributeValidationError.OUTSIDE_RANGE
        const lowPred = !isNonNaNNumber(range.min) || range.min <= value
        const hiPred = !isNonNaNNumber(range.max) || range.max >= value
        const inRange: boolean = lowPred && hiPred
        switch (inRange) {
          case true:
            {
              res.error = null
              res.isValid = true
            }
            break
          default: {
            debug && console.log(`${value} ${res.error}`)
          }
        }
      }
      break
    default: {
      debug && console.log(`${value} ${res.error}`)
    }
  }
  return res
}

export const validAttributeBooleanValue = (value: any): AttributeValidationResult => {
  const isBoolean = typeof value === 'boolean'
  const res: AttributeValidationResult = {
    isValid: false,
    error: AttributeValidationError.NOT_BOOLEAN,
  }
  switch (isBoolean) {
    case true:
      {
        res.error = null
      }
      break
    default: {
      debug && console.log(`${value} ${res.error}`)
    }
  }
  return res
}

export const validAttributeEnumValue = (value: any, enumeration: MapLike<string | number>): AttributeValidationResult => {
  const isPossibleKey = ['string', 'number'].includes(typeof value)

  const res: AttributeValidationResult = {
    isValid: false,
    error: AttributeValidationError.NOT_ENUM_VALUE,
  }
  if (isPossibleKey) {
    const isEnumKey = Object.values(enumeration).includes(value)
    if (isEnumKey) {
      ;(res.error = null), (res.isValid = true)
    } else {
      console.log(`${value} ${res.error}`)
    }
  }
  return res
}

export const validAttributePresent = (value: any): AttributeValidationResult => {
  const isPresent = true

  const res: AttributeValidationResult = {
    isValid: false,
    error: AttributeValidationError.NOT_ENUM_VALUE,
  }
  if (isPresent) {
    ;(res.error = null), (res.isValid = true)
  }
  return res
}

export const keysArePopulated = (value: any) => {
  if (typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, isKnownValue(v, false)]))
  } else {
    return {}
  }
}

/** for dev, show which keys are null or undefined, */
export const keysArePopulatedString = (value: any) => {
  const x = keysArePopulated(value)
  const sep = ', '
  return Object.entries(x).reduce((a, [k, b], i) => {
    a += `${i === 0 ? '' : sep}${k}: ${b}`
    return a
  }, '')
}
